<!-- 储值教学 -->
<template>
  <div class="tutoring">
    <a
      :href="store.state.articlesData.payUrl2CN"
      target="_blank"
      v-if="XhLang == 'cn'"
    >
      <img
        class="market_pay_teaching"
        src="../../../assets/images/cn/tutoring.png"
      >
    </a>
    <a
      :href="store.state.articlesData.payUrl2TH"
      target="_blank"
      v-if="XhLang == 'th'"
    >
      <img
        class="market_pay_teaching"
        src="../../..//assets/images/th/tutoring.png"
      >
    </a>
    <a
      :href="store.state.articlesData.payUrl2EN"
      target="_blank"
      v-if="XhLang == 'en'"
    >
      <img
        class="market_pay_teaching"
        src="../../../assets/images/en/tutoring.png"
      >
    </a>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { useStore } from "vuex";
const store = useStore();
const XhLang = locale.value;
</script>


<style lang="scss" scoped>
.tutoring {
  position: fixed;
  left: 0;
  top: 15% !important;
  z-index: 5;
  margin: 1rem 0.15rem;
  a {
    width: 1.8rem;
    display: block;
    img {
      width: 1.8rem;
    }
  }
}
</style>